import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import {
  addCustomPlace as generatedAddCustomPlaceGoogle,
  addCustomPlace1 as generatedAddCustomPlaceEv,
  addCustomPlaceBlacklistEntry as generatedAddCustomPlaceBlacklistEntry,
  deleteCustomPlace as generatedDeleteCustomPlace,
  deleteCustomPlaceBlacklistEntry as generatedDeleteCustomPlaceBlacklistEntry,
  getCustomPlaces as generatedGetCustomPlaces,
} from '@generated/search-bff/controllers/autosuggestion-admin/autosuggestion-admin';
import {
  type AddCustomPlaceGoogleRequest,
  type AddCustomPlaceBlacklistRequest,
  type AddCustomPlaceEvRequest,
  type CustomPlaceBlacklistResponse,
  type CustomPlaceResponse,
  type GetCustomPlacesParams,
} from '@generated/search-bff';

export async function getCustomPlaces(params: GetCustomPlacesParams, apiConfig: ApiConfig): Promise<ApiResult<CustomPlaceResponse[]>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'getCustomPlaces');
    const data = await generatedGetCustomPlaces(params, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export async function addCustomPlace(payload: AddCustomPlaceGoogleRequest, apiConfig: ApiConfig): Promise<ApiResult<void>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'addCustomPlace');
    const data = await generatedAddCustomPlaceGoogle(payload, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export async function addCustomPlaceEv(payload: AddCustomPlaceEvRequest, apiConfig: ApiConfig): Promise<ApiResult<void>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'addCustomPlaceEv');
    const data = await generatedAddCustomPlaceEv(payload, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export async function addCustomPlaceBlacklistEntry(
  payload: AddCustomPlaceBlacklistRequest,
  apiConfig: ApiConfig,
): Promise<ApiResult<CustomPlaceBlacklistResponse>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'addCustomPlaceBlacklistEntry');
    const data = await generatedAddCustomPlaceBlacklistEntry(payload, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export async function deleteCustomPlace(placeId: string, apiConfig: ApiConfig): Promise<ApiResult<void>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'deleteCustomPlace');
    const data = await generatedDeleteCustomPlace(placeId, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export async function deleteCustomPlaceBlacklistEntry(placeId: string, apiConfig: ApiConfig): Promise<ApiResult<void>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'deleteCustomPlaceBlacklistEntry');
    const data = await generatedDeleteCustomPlaceBlacklistEntry(placeId, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
